const styles = (theme) => ({
  errorMessage: {
    color: theme.palette.error.main,
    marginLeft: '14px',
  },
})

export default styles
